import changePasswordRequest from "./changePasswordRequest";

export default {
  changePasswordRequest
}